<template>
  <div class="container-fluid">
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>import CSV</h5>
      </div>
      <div class="col-3">
        <button id="backBtn" type="button" class="btn-sm btn-outline-info" v-on:click="back">キャンセルする</button>
      </div>
      <div class="col-3">
        <button type="button" class="btn-sm btn-outline-primary" v-on:click="download">フォーマットを出力する</button> 
      </div>
    </div>
    <div class="row">
      <div class="col-1">
      </div>
      <div class="col-11">
        <form enctype="multipart/form-data" @submit.prevent="upload">
          <input type="file" ref="file" name="csvfile" v-on:change="selectedFile"/>
          <button class="btn btn-info">Upload</button>
        </form>
      </div>
    </div>
    
    <p>{{message}}</p>
  </div>
</template>

<script>
import axios from 'axios'
import FileSaver from 'file-saver'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Import',
  mixins: [sessions,path,headers],
  props: ['realms'],
  data: function(){
    return {
      message: '',
      uploadFile: null
    }
  },
  methods: {
    selectedFile(event){
      let files = event.target.files
      this.uploadFile = files[0]
    },
    upload(){
      if (this.uploadFile === null){
        alert('ファイルが指定されていません。')
        return
      }
      var blob = new Blob([this.uploadFile], {type: 'application/octet-stream'})
      var fileName = this.uploadFile.name
      var hospitalCode = this.$store.getters.hospital.code
      this.$cognito.isAuthenticated().then((session) => {
      if(session){
        var accessToken = this.getAccessToken(this.$cognito,session)
        axios.post("/api/emergency/room/csv/" + hospitalCode + "/" + fileName, blob,{
              headers: this.headersUploadStream(accessToken)
        }).then(res => {
          if(res.errorMessage) {
            this.message = res.errorMessage
          } else {
            this.reset()
            alert('ファイルをアップロードしました。')
            this.back()
          }
        })
      }}).catch((err) => {
        this.message = err.message
      })
    },
    back() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/emergency/group/index'))
    },
    reset() {
      var input = this.$refs.file
      input.value = ''
      this.uploadFile = null
    },
    download() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var fileName = 'emergency-rooms.csv'
          axios.post("/api/csv-format/download/", {
              fileName: fileName
            },{
              headers: this.headers(accessToken),
              responseType: "blob"
          }).then(response => {
            const blob = new Blob([response.data], {
              type: response.data.type
            })
            FileSaver.saveAs(blob, fileName)
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch((err) => {
        this.message = err.message
      })
    }
  } 
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#backBtn {
  float:right;
}
#register_button {
  margin-top: 30px;
}
</style>